import { getPlatformStorage } from "@lib/platform/storage";

/** Versioned so a future redesign can re-trigger the intro for existing installs. */
export const WELCOME_SEEN_KEY = "komut.welcome_seen.v1";

let cachedSeen: Promise<boolean> | null = null;

async function readSeen(): Promise<boolean> {
  try {
    const value = await getPlatformStorage().get(WELCOME_SEEN_KEY);
    return value === "true";
  } catch {
    return false;
  }
}

/** Memoized first read of the install-scoped "seen" flag. */
export function getWelcomeSeen(): Promise<boolean> {
  if (!cachedSeen) cachedSeen = readSeen();
  return cachedSeen;
}

/** Marks the intro as seen for this install (survives logout; cleared by uninstall). */
export async function markWelcomeSeen(): Promise<void> {
  cachedSeen = Promise.resolve(true);
  try {
    await getPlatformStorage().set(WELCOME_SEEN_KEY, "true");
  } catch {
    // Best-effort: a failed write only means the intro may show again.
  }
}
